import {
    Alert,
    Badge,
    Button,
    Col,
    FormControl, FormLabel,
    ListGroup,
    ListGroupItem,
    ProgressBar,
    Row,
    Spinner
} from "react-bootstrap";
import {useEffect, useRef, useState} from "react";
import axios from "axios";
import Helper from "../helper";
import { v4 as uuidv4 } from 'uuid';
import {NotificationManager} from "react-notifications";
import {createUseStyles} from "react-jss";



const useStyle =createUseStyles({
    vcenter:{
        display:'flex',
        flexDirection:'column',
        justifyContent:'center',
    },
    btnUpload:{
        border:'1px solid #0b4e2f',
        width:180,
        height: 40,
        lineHeight: 2.2,
        textAlign:'center',
        color: 'white',
        background: '#198754',
        transition:' all 0.3s',
        boxShadow:'2px 2px 2px #888888',
        '&:hover':{
            border:'1px solid #7c600c',
            background: '#da930a',
            boxShadow:'3px 3px 3px #888888',
        }
    }
})


const VideoUploader = ({courseID,onStart,onFinished}) => {

    const [currentFiles, setCurrentFiles] = useState([]);
    const [isStarted,setIsStarted] = useState(false);
    const [isFinished,setIsFinished] = useState(false);
    const _currentFiles = useRef([]);
    const timers = useRef({});
    const classes = useStyle();
    const fileElement = useRef();

    useEffect(() => {
        return () => {
            Object.keys(timers.current).map(key=>{
                clearInterval(timers.current[key]);
            })
        };
    }, []);

    const onFileChanged = e =>{
        setIsFinished(false);
        for (let file of e.target.files) {
            let uid = uuidv4();
            _currentFiles.current.push({
                uid,
                file,
                name:file.name,
                newName:void 0,
                description:void 0,
                percentage:0,
                host_percentage:0,
                videoID:void 0,
                error:void 0,
                uploading:false,
                isFinished:false,
            });
        }
        setCurrentFiles([..._currentFiles.current]);
        e.target.value=null;
    }

    const clearVideo = ()=>{
        fileElement.value=null;
        _currentFiles.current=[];
        setCurrentFiles([..._currentFiles.current]);
    }

    const onNameChanged = (video,e) =>{
        let v = e.target.value;
        video.newName=v;
    }
    const onDescriptionChanged = (video,e) =>{
        let v = e.target.value;
        video.description=v;
    }

    const uploader = () => {
        _currentFiles.current=_currentFiles.current.filter(f=>!f.isFinished);
        setCurrentFiles(old=>[..._currentFiles.current]);
        setIsStarted(true);
        setIsFinished(false);
        if(onStart)onStart();
        for (let _currentFile of _currentFiles.current) {
            let formData = new FormData();
            formData.append('course_id',courseID);
            formData.append('file',_currentFile.file);
            formData.append('uid',_currentFile.uid);
            formData.append('name',_currentFile.newName || _currentFile.name);
            formData.append('description',_currentFile.description);
            _currentFile.uploading=true;
            axios.post(Helper.VIMEO('upload'), formData, {
                headers: {"Content-Type": "multipart/form-data"},
                onUploadProgress: function(progressEvent) {
                    let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                    _currentFile.host_percentage=percentCompleted;
                    setCurrentFiles(old=>[..._currentFiles.current]);
                }
            }).then(res => {
                if(res.data.error){
                    clearInterval(timers.current[_currentFile.uid]);
                    NotificationManager.error(res.data.error);
                }
            });
            timers.current[_currentFile.uid]=setInterval(()=>{
                axios.get(Helper.VIMEO('progress',[
                    `uid=${_currentFile.uid}`
                ])).then(res=>{
                    let {progress} = res.data;
                    // console.log('PROGRESS==', _currentFile.uid, progress);
                    _currentFile.percentage=progress.percentage;
                    _currentFile.videoID=progress.videoID;
                    if(progress.videoID){
                        // console.log('FINISHED==', _currentFile.uid, progress);
                        _currentFile.uploading=false;
                        _currentFile.isFinished=true;
                       timers.current[`finished_${_currentFile.uid}`] = setTimeout(()=>{
                            _currentFiles.current=_currentFiles.current.filter(f=>f!=_currentFile);
                            setCurrentFiles(old=>[..._currentFiles.current]);
                        },1000);
                        clearInterval(timers.current[_currentFile.uid])
                    }
                    setCurrentFiles(old=>[..._currentFiles.current]);
                    let notFinished = _currentFiles.current.find(f=>!f.isFinished);
                    if(!notFinished && onFinished) {
                        onFinished(true);
                        setIsFinished(true);
                        setIsStarted(false);
                    }
                });
            },500);
        }
        setCurrentFiles([..._currentFiles.current]);
    }

    return <>
        {!isStarted?
            <div className="text-center mt-4 mb-2">
                <FormLabel className={classes.btnUpload}>
                    <FormControl style={{display:'none'}} ref={fileElement} multiple type="file" onChange={onFileChanged.bind(this)}/>
                    UPLOAD VIDEOS
                </FormLabel>
            </div>
            :
            <Alert variant='warning' className="text-center mt-4 mb-4">Please Wait...</Alert>
        }
        {currentFiles.length>0 &&
            <>
                {isStarted?
                    <h4>Files is uploading... <Spinner animation="border" /></h4>
                    :
                    <h4>Files will be upload</h4>
                }
            </>
        }
        {currentFiles.length > 0 ?
            <ListGroup>
                {currentFiles?.map((video,i) =>
                    <ListGroupItem key={video.uid} style={{backgroundColor:i%2!=0?'#d9d9d9':'#fff'}}>
                        <Row>
                            <Col>
                                <div>
                                    <FormControl placeholder={video.file.name} defaultValue={video.file.name} disabled={video.uploading} onChange={onNameChanged.bind(this,video)}/>
                                </div>
                                <div className="mt-2">
                                    <FormControl as="textarea" placeholder="Video description" disabled={video.uploading} onChange={onDescriptionChanged.bind(this,video)}/>
                                </div>
                            </Col>
                            <Col className={classes.vcenter}>
                                <div>
                                    {video.isFinished?
                                        <Badge bg='success'>Upload Success!</Badge>
                                        :
                                        <>
                                            <ProgressBar className="mb-1" variant={video.isFinished?'success':'info'} now={video.host_percentage} label={`Host ${video.host_percentage}%`}/>
                                            <ProgressBar variant={video.isFinished?'success':'primary'} now={video.percentage} label={`Vimeo ${video.percentage}%`}/>
                                        </>
                                    }
                                </div>
                            </Col>
                        </Row>
                    </ListGroupItem>
                )}
            </ListGroup>
            :
            null
        }
        <div className="mt-2 mb-4 text-center">
            {currentFiles.length>0 && !isFinished &&
                <Row className="justify-content-center">
                    <Col xs={6} md={2}>
                        <Button style={{width:'100%'}} disabled={isStarted} onClick={uploader.bind(this)}>Upload</Button>
                    </Col>
                    <Col xs={6} md={2}>
                        <Button style={{width:'100%'}} variant='danger' disabled={isStarted} onClick={clearVideo.bind(this)}>Clear</Button>
                    </Col>
                </Row>
            }
            <hr/>
        </div>
    </>
}
export default VideoUploader;